import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type PhoneboothScreenState = 'home' | 'status' | 'receiveTransmission' | 'transmitting';
export type ScreenCursorState = 'none' | 'hover' | 'pointer';

export interface PhoneboothState {
  state: PhoneboothScreenState;
  cursor: ScreenCursorState;
}

const initialState: PhoneboothState = {
  state: 'home',
  cursor: 'none',
};

const phoneboothSlice = createSlice({
  name: 'phonebooth',
  initialState,
  reducers: {
    updatePhoneboothState(state, action: PayloadAction<PhoneboothScreenState>) {
      state.state = action.payload;
    },
    updateScreenCursorState(state, action: PayloadAction<ScreenCursorState>) {
      state.cursor = action.payload;
    },
  },
});

export const { updatePhoneboothState, updateScreenCursorState } = phoneboothSlice.actions;
export default phoneboothSlice.reducer;
